<template>
  <v-container fluid class="white py-8 py-md-16" id="verticals">
    <v-container>
      <v-row class="mb-10">
        <v-col cols="12" class="text-center">
          <span
            class="overline secondary--text font-weight-bold"
            data-aos="fade-down"
          >
            VERTICALES
          </span>
          <h2
            class="display-1 greydark--text font-weight-bold mt-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Elegí la vertical para tu industria
          </h2>
          <p
            class="text-h6 greylight--text mt-4 mx-auto"
            style="max-width: 700px;"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Plataformas especializadas, no soluciones genéricas
          </p>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col
          v-for="(card, index) in verticals"
          :key="card.title"
          cols="12"
          md="5"
          data-aos="fade-up"
          :data-aos-delay="300 + (index * 100)"
        >
          <VerticalCard
            :title="card.title"
            :subtitle="card.subtitle"
            :bullets="card.bullets"
            :color="card.color"
            :icon="card.icon"
            :route="card.route"
            :cta-label="card.ctaLabel"
            :status-chip="card.statusChip"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import VerticalCard from './VerticalCard.vue';

export default {
  name: 'VerticalSelector',
  components: { VerticalCard },
  data() {
    return {
      verticals: [
        {
          title: 'TradeFlow',
          subtitle: 'Gestión inteligente de operaciones de comercio exterior',
          bullets: [
            'Automatización de despachos y documentos',
            'Trazabilidad completa de cargas',
            'Integración con agentes y despachantes',
          ],
          color: '#00695C',
          icon: 'mdi-airplane-takeoff',
          route: '/tradeflow',
          ctaLabel: 'Conocer TradeFlow',
          statusChip: 'Disponible',
        },
        {
          title: 'InsureFlow',
          subtitle: 'Operaciones de seguros sin fricciones ni papeles',
          bullets: [
            'Gestión de pólizas y siniestros',
            'Validación automática de documentación',
            'Reportes regulatorios automatizados',
          ],
          color: '#1565C0',
          icon: 'mdi-shield-account',
          route: null,
          ctaLabel: 'Dejanos tu interés',
          statusChip: 'Próximamente',
        },
      ],
    };
  },
};
</script>
